import { useEffect, useRef, useState } from 'react';
import './App.css';
import Chart from 'react-google-charts';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Calendar } from 'primereact/calendar';
import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { ReactComponent as PPGEEIcon } from './images/ppgee.svg';
import { ReactComponent as LatesIcon } from './images/lates.svg';
import { Avatar } from 'primereact/avatar';
import { AutoComplete, AutoCompleteCompleteEvent } from 'primereact/autocomplete';
import { Panel } from 'primereact/panel';
import { Knob } from 'primereact/knob';
import { Tag } from 'primereact/tag';
import { MdHistory } from "react-icons/md";
import { GiEnergise } from "react-icons/gi";
import * as Data from './Data';
import { ProgressBar } from 'primereact/progressbar';
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { InputText } from 'primereact/inputtext';
import { Divider } from 'primereact/divider';
import { Login } from './components/Login';

const GiEnergiseIcon: any = GiEnergise;
const MdHistoryIcon: any = MdHistory;

function App() {
  const [climateData, setClimateData] = useState<Array<any>>([])
  const [flowData, setFlowData] = useState<Array<any>>([])
  const [energyData, setEnergyData] = useState<Array<any>>([])
  const [e1Data, setE1Data] = useState<Array<any>>([])
  const [e2Data, setE2Data] = useState<Array<any>>([])
  // const [data, setData] = useState<Array<any>>([])
  const [isLoading, setIsLoading] = useState(false)
  const [dates, setDates] = useState<Date[] | null>(null)
  const [electrolyzers, setElectrolyzers] = useState<Array<any> | null>(null)
  const [electrolyzer, setElectrolyzer] = useState<any>(null)
  const [token, setToken] = useState<string | null>(() => Data.getStoredAuth().token)
  const [currentUser, setCurrentUser] = useState<string | null>(() => Data.getStoredAuth().username)
  const [datesAvailable, setDatesAvailable] = useState<Array<any> | null>(null)
  const CHECK_INTERVAL = 5000; // Intervalo de checagem em milissegundos (5 segundos)
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const handleLoginSuccess = (newToken: string, newUsername: string) => {
    setToken(newToken)
    setCurrentUser(newUsername)
  }

  const handleLogout = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
    }
    Data.logout()
    setToken(null)
    setCurrentUser(null)
    setElectrolyzers(null)
    setElectrolyzer(null)
    setEnergyData([])
    setClimateData([])
    setFlowData([])
    setE1Data([])
    setE2Data([])
    setDates(null)
    setDatesAvailable(null)
  }

  const [energy, setEnergy] = useState<number>(0.0)
  const [isLoadingElectrolyzer, setLoadingElectrolyzer] = useState(false)
  const [btMacInput, setBtMacInput] = useState<string>('')
  const [btMacSaving, setBtMacSaving] = useState(false)
  const updateCharts = async (electrolyzer: any) => {
    if (token !== null && electrolyzer !== null) {
      const data = await Data.getLatestData(token, electrolyzer)
      console.log('Latest Data', data)

      setEnergyData((prev: any[]) => {
        return [...prev, [new Date(data.instant), data.voltage2, data.current + data.current2, data.voltage2 * (data.current + data.current2), data.voltage]];
      })

      setE1Data((prev: any[]) => {
        return [...prev, [new Date(data.instant), data.voltage2, data.current, data.voltage2 * data.current]];
      })

      setE2Data((prev: any[]) => {
        return [...prev, [new Date(data.instant), data.voltage2, data.current2, data.voltage2 * data.current2]];
      })

      setClimateData((prev: any[]) => {
        return [...prev, [new Date(data.instant), data.temperature, data.humidity]];
      })

      setFlowData((prev: any[]) => {
        const f1 = data.current * 13.87313 - 2.83079
        const f2 = data.current2 * 13.87313 - 2.83079
        return [...prev, [new Date(data.instant), data.h2_flow, data.o2_flow, f1, f2, f1 + f2]];
      })
    }
  }
  const updateElectrolyzer = async (electrolyzer: any) => {
    if (token !== null && electrolyzer !== null) {
      const data: any = await Data.getElectrolyzer(token, electrolyzer)
      console.log('Electrolyzer up:', data)
      setElectrolyzer(data)
      setBtMacInput(data.bt_mac || '')
      setLoadingElectrolyzer(false)
    }
  }

  const saveBtMac = async () => {
    if (token !== null && electrolyzer !== null) {
      setBtMacSaving(true)
      try {
        const updated = await Data.updateElectrolyzerConfig(token, electrolyzer.id, btMacInput.toUpperCase().trim())
        setElectrolyzer((prev: any) => ({ ...prev, bt_mac: updated.bt_mac }))
        console.log('bt_mac salvo:', updated.bt_mac)
      } catch (e) {
        console.error('Erro ao salvar bt_mac:', e)
      } finally {
        setBtMacSaving(false)
      }
    }
  }
  const getData = async (date1: Date, date2: Date, electrolyzer: any) => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current); // Parar o update do real time
    }
    if (date1 !== null && date2 !== null && electrolyzer !== null && token !== null) {
      const data = await Data.getDataBetween(date1, date2, electrolyzer, token)
      var dataE = [['Instante (s)', 'Tensão Saída (V)', 'Corrente Total (A)', 'Potência (W)', 'Tensao Entrada (V)']]
      var dataE1 = [['Instante (s)', 'Tensão Saída (V)', 'Corrente 1 (A)', 'Potência (W)']]
      var dataE2 = [['Instante (s)', 'Tensão Saída (V)', 'Corrente 2 (A)', 'Potência (W)']]
      var dataC = [['Instante (s)', 'Temperatura (°C)', 'Umidade (%)']]
      // var dataF = [['Instante (s)', 'Fluxo H2 (L/min)', 'Fluxo O2 (L/min)']]
      var dataF: Array<Array<any>> = [['Instante (s)', 'Fluxo Medido H2 (ml/min)', 'Fluxo Medido O2 (ml/min)', 'Fluxo Teórico G1 (ml/min)', 'Fluxo Teórico G2 (ml/min)', 'Fluxo Teórico Total G1+G2 (ml/min)']]
      // var data1 = [['Instante (s)', 'Tensao (V)', 'Corrente (mA)', 'Fluxo H2 (L/min)', 'Fluxo O2 (L/min)', 'Temperatura (°C)']]
      if (data.length > 1)
        data.map((d: any, i: number, vector: any) => {
          const potency = d.voltage2 * (d.current + d.current2)
          const p1 = d.voltage2 * d.current
          const p2 = d.voltage2 * d.current2
          if (i > 0) {
            // console.log('D', new Date(d.instant).getTime())
            // console.log('V[i]', new Date(vector[i].instant).getTime())
            // console.log('d', d, 'index', index, 'vector', vector)
            // console.log('d', d)
            const dt = (new Date(d.instant).getTime() - new Date(vector[i - 1].instant).getTime()) / 1000 / 3600;
            // const dt = 0
            setEnergy(energy + potency * dt)
          }
          const f1 = d.current * 13.87313 - 2.83079
          const f2 = d.current2 * 13.87313 - 2.83079
          dataE.push([new Date(d.instant), d.voltage2, d.current + d.current2, potency, d.voltage])
          dataE1.push([new Date(d.instant), d.voltage2, d.current, p1])
          dataE2.push([new Date(d.instant), d.voltage2, d.current2, p2])
          dataC.push([new Date(d.instant), d.temperature, d.humidity])
          dataF.push([new Date(d.instant), d.h2_flow, d.o2_flow, f1, f2, f1 + f2])
          // dataF.push([new Date(d.instant), d.h2_flow, d.o2_flow])
          // data1.push([new Date(d.instant), d.voltage, d.current, d.h2_flow, d.o2_flow, d.temperature])
        })
      // console.log(data1)
      // setData(data1)
      setEnergyData(dataE)
      setE1Data(dataE1)
      setE2Data(dataE2)
      setClimateData(dataC)
      setFlowData(dataF)
      setIsLoading(false)
      const today = new Date()
      if ((date2.getMonth() === today.getMonth() && date2.getDate() === today.getDate() && date2.getFullYear() === today.getFullYear())) {
        intervalRef.current = setInterval(() => {
          updateCharts(electrolyzer);
          // updateElectrolyzer(electrolyzer)
        }, CHECK_INTERVAL);
      }
    }
  }

  const getDates = async () => {
    if (electrolyzer !== null && token !== null) {
      console.log('Getting Dates with Electrolyzer:', electrolyzer, ' Token:', token)
      const dates = await Data.getAvailbleDates(token, electrolyzer)
      console.log('Availables Dates:', dates)
      setDatesAvailable(dates)
    }
  }
  const energyOptions = {
    title: 'Variáveis Elétricas do Eletrolizador ' + electrolyzer?.local?.name + (dates && dates[0] && (' (' + dates[0].toLocaleDateString('pt-BR') + ' - ') + (dates && dates[1] && (dates[1].toLocaleDateString('pt-BR') + ')'))),
    hAxis: { titleTextStyle: { color: "#333" }, format: 'HH:mm' },
    vAxis: { minValue: 0, textPosition: 'in' },
    legend: { position: "bottom" },
    seriesType: "line",
    series: {
      2: { type: "area" },
    },
    chartArea: { width: 820 },
    explorer: {
      axis: 'horizontal',
      keepInBounds: true,
      maxZoomIn: 0.01
    }
  };
  const e1Options = {
    title: 'Variáveis Elétricas do Eletrolizador 1 ' + electrolyzer?.local?.name + (dates && dates[0] && (' (' + dates[0].toLocaleDateString('pt-BR') + ' - ') + (dates && dates[1] && (dates[1].toLocaleDateString('pt-BR') + ')'))),
    hAxis: { titleTextStyle: { color: "#333" }, format: 'HH:mm' },
    vAxis: { minValue: 0, textPosition: 'in' },
    legend: { position: "bottom" },
    seriesType: "line",
    series: {
      2: { type: "area" },
    },
    chartArea: { width: 400 },
    explorer: {
      axis: 'horizontal',
      keepInBounds: true,
      maxZoomIn: 0.01
    }
  };
  const e2Options = {
    title: 'Variáveis Elétricas do Eletrolizador 2 ' + electrolyzer?.local?.name + (dates && dates[0] && (' (' + dates[0].toLocaleDateString('pt-BR') + ' - ') + (dates && dates[1] && (dates[1].toLocaleDateString('pt-BR') + ')'))),
    hAxis: { titleTextStyle: { color: "#333" }, format: 'HH:mm' },
    vAxis: { minValue: 0, textPosition: 'in' },
    legend: { position: "bottom" },
    seriesType: "line",
    series: {
      2: { type: "area" },
    },
    chartArea: { width: 400 },
    explorer: {
      // actions: ['dragToZoom', 'rightClickToReset'],
      axis: 'horizontal',
      keepInBounds: true,
      maxZoomIn: 0.01
    }
  };
  const flowOptions = {
    title: 'Variáveis Pneumáticas do Eletrolizador ' + electrolyzer?.local?.name + (dates && dates[0] && (' (' + dates[0].toLocaleDateString('pt-BR') + ' - ') + (dates && dates[1] && (dates[1].toLocaleDateString('pt-BR') + ')'))),
    hAxis: { titleTextStyle: { color: "#333" }, format: 'HH:mm' },
    vAxis: { minValue: 0, maxValue: 70, textPosition: 'in', gridlines: { count: 5 } },
    legend: { position: "bottom" },
    seriesType: "line",
    colors: ['#109618', '#990099', '#FF9900'],
    chartArea: { width: 400 },
    explorer: {
      axis: 'horizontal',
      keepInBounds: true,
      maxZoomIn: 1
    }
  };
  const climateOptions = {
    title: 'Variáveis Climáticas do Eletrolizador ' + electrolyzer?.local?.name + (dates && dates[0] && (' (' + dates[0].toLocaleDateString('pt-BR') + ' - ') + (dates && dates[1] && (dates[1].toLocaleDateString('pt-BR') + ')'))),
    hAxis: { titleTextStyle: { color: "#333" }, format: 'HH:mm' },
    vAxis: { minValue: 0, textPosition: 'in' },
    legend: { position: "bottom" },
    seriesType: "line",
    colors: ['#DC3912', '#3366CC',],
    chartArea: { width: 400 },
    explorer: {
      axis: 'horizontal',
      keepInBounds: true,
      maxZoomIn: 0.01
    }
  };
  const dateTemplate = (date: any) => {
    if (datesAvailable !== null) {
      if (datesAvailable.findIndex((d) => {
        if (d) {
          const dt = d.split('-')
          return (Number(dt[2]) === date.day && Number(dt[1]) === (date.month + 1) && Number(dt[0]) === date.year)
        }
      }) > -1) {
        return (
          <Avatar label={date.day} style={{ backgroundColor: '#07A5C4', color: '#ffffff' }} shape="circle" />
        );
      }
      return date.day;
    }
  }
  const getElectrolyzers = async () => {
    if (token !== null) {
      try {
        const data = await Data.getElectrolyzers(token)
        setElectrolyzers(data)
        console.log('Electrolizers', data)
        setLoadingElectrolyzer(false)
      } catch (err: any) {
        console.error('Erro ao carregar eletrolizadores:', err)
        if (err?.response?.status === 401) {
          handleLogout()
        }
      }
    }
  }
  useEffect(() => {
    if (dates && dates[1] !== null && electrolyzer !== null) {
      setIsLoading(true)
      getData(dates[0], dates[1], electrolyzer)
    }
  }, [dates])
  useEffect(() => {
    getDates()
    console.log('Electrolyzer', electrolyzer)
    if (electrolyzer) setBtMacInput(electrolyzer.bt_mac || '')
  }, [electrolyzer])
  useEffect(() => {
    if (token) {
      getElectrolyzers()
    }
  }, [token])
  const [filteredElectrolyzers, setFilteredElectrolyzers] = useState<Array<any>>([])

  const search = (event: AutoCompleteCompleteEvent) => {
    if (electrolyzers !== null) {

      // Timeout to emulate a network connection
      setTimeout(() => {
        let _filteredElectrolyzers;

        if (!event.query.trim().length) {
          _filteredElectrolyzers = [...electrolyzers];
        }
        else {
          _filteredElectrolyzers = electrolyzers.filter((e) => {
            return e.name.toLowerCase().startsWith(event.query.toLowerCase());
          });
        }
        setFilteredElectrolyzers(_filteredElectrolyzers);
      }, 250);
    }
  }


  // const [stream, setStream] = useState<Array<any>>([])

  // const ws = useRef<WebSocket | null>(null);

  // useEffect(() => {
  //   ws.current = new WebSocket('wss://h2.gearspark.com.br/ws/collects/');
  //   ws.current.onmessage = (event) => {
  //     const newData = JSON.parse(event.data);
  //     setStream((prevData) => [...prevData, newData]);
  //   };

  //   return () => {
  //     ws.current?.close();
  //   };
  // }, []);
  const headerElectrolyzer = (options: any) => {
    const className = `${options.className} justify-content-space-between`;
    return (
      <div className={className}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <GiEnergiseIcon size={32} style={{ marginRight: 10 }} />
          {/* <Avatar image="https://static.longi.com/8_ced6621d2b.png" size="large" shape="circle" /> */}
          <div style={{ paddingRight: 10 }}>Eletrolizador</div>
          {electrolyzers === null ?
            <ProgressBar mode="indeterminate" style={{ height: '6px', width: '300px' }}></ProgressBar>
            :
            <>
              <AutoComplete field='local.name' value={electrolyzer} suggestions={filteredElectrolyzers} completeMethod={search}
                onChange={(e) => {
                  setEnergyData([])
                  setDates(null)
                  setDatesAvailable(null)
                  setElectrolyzer(e.value)
                }}
                dropdown />
              {electrolyzer === null ? <></> : <Button style={{ marginLeft: 10 }} icon='pi pi-sync' rounded severity="success"
                onClick={(e) => {
                  setLoadingElectrolyzer(true)
                  updateElectrolyzer(electrolyzer)
                }} />}
            </>
          }
        </div>
        <div>
          {options.togglerElement}
        </div>
      </div>
    )
  }
  const headerHistory = (options: any) => {
    const className = `${options.className} justify-content-space-between`;

    return (
      <div className={className}>
        <div
          // className="flex align-items-center gap-2"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <MdHistoryIcon size={32} style={{ marginRight: 10 }} />

          <span className="font-bold"></span>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ paddingRight: 10 }}>Período</div>
            {datesAvailable === null ?
              <ProgressBar mode="indeterminate" style={{ height: '6px', width: '300px' }}></ProgressBar>
              :
              <Calendar value={dates} onChange={(e: any) => setDates(e.value)} selectionMode="range" readOnlyInput hideOnRangeSelection showIcon showButtonBar dateFormat="dd/mm/yy" dateTemplate={dateTemplate} />
            }
          </div>
        </div>
        <div>
          {options.togglerElement}
        </div>
      </div>
    );
  };

  if (!token) {
    return (
      <PrimeReactProvider>
        <Login onLoginSuccess={handleLoginSuccess} />
      </PrimeReactProvider>
    );
  }

  return (
    <div className="App" style={{ height: '100%' }}>
      <PrimeReactProvider >
        <div style={{ paddingTop: 10, paddingBottom: 10, backgroundColor: 'lightgray', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
          <LatesIcon width={200} height={40} />
          {/* <GlobeIcon width={40} height={40} /> */}
          &nbsp;
          <div style={{ fontSize: 32, fontWeight: 'bold', color: 'black' }}>MAI/DAI - Green Power</div>
          <PPGEEIcon width={200} height={40} />
          <div style={{ position: 'absolute', right: 20, display: 'flex', alignItems: 'center', gap: 12 }}>
            {currentUser && (
              <span style={{ fontSize: 14, fontWeight: 600, color: '#1e293b', display: 'flex', alignItems: 'center', gap: 6, backgroundColor: '#f1f5f9', padding: '6px 12px', borderRadius: '20px' }}>
                <i className="pi pi-user" style={{ color: '#059669' }} /> {currentUser}
              </span>
            )}
            <Button
              label="Sair"
              icon="pi pi-sign-out"
              size="small"
              severity="danger"
              outlined
              onClick={handleLogout}
            />
          </div>
        </div>
        <div style={{ fontWeight: 'bold', fontSize: 20, backgroundColor: 'gray', color: 'white' }}>MONITORAMENTO DE ELETROLIZADORES</div>
        {/* <Calendar value={dates} onChange={(e: any) => setDates(e.value)} selectionMode="range" readOnlyInput hideOnRangeSelection showIcon showButtonBar /> */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>
          <Panel headerTemplate={headerElectrolyzer}
            // style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}
            style={{ width: 850 }} toggleable
          >
            {electrolyzer &&
              <>
                {
                  isLoadingElectrolyzer ?
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '70vh' }}>
                      <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" animationDuration=".5s" />
                    </div>
                    :
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                        <div className="p-inputgroup flex-1" style={{ marginBottom: 5 }}>
                          <Button label="Etiqueta" size="small" />
                          <InputText className="p-inputtext-sm" variant="filled" value={electrolyzer.label} />
                        </div>
                        {/* --- Seção de Configuração Bluetooth --- */}
                        <div style={{ width: '100%', marginBottom: 10 }}>
                          <Divider align="center">
                            <span className="p-tag" style={{ backgroundColor: '#6c757d' }}>Configuração do Dispositivo</span>
                          </Divider>
                          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                            <div className="p-inputgroup flex-1">
                              <Button label="MAC Raspberry Pi" size="small" severity="secondary" />
                              <InputText
                                id="field-pi-mac"
                                className="p-inputtext-sm"
                                variant="filled"
                                value={electrolyzer.pi_mac || '(não registrado)'}
                                readOnly
                                style={{ fontFamily: 'monospace', color: '#555' }}
                              />
                            </div>
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                            <div className="p-inputgroup flex-1">
                              <Button label="MAC Bluetooth" size="small" severity="info" />
                              <InputText
                                id="field-bt-mac"
                                className="p-inputtext-sm"
                                placeholder="Ex: D4:8C:49:EA:86:8A"
                                value={btMacInput}
                                onChange={(e) => setBtMacInput(e.target.value)}
                                style={{ fontFamily: 'monospace' }}
                              />
                            </div>
                            <Tag
                              value={electrolyzer.bt_mac ? 'Configurado' : 'Não configurado'}
                              severity={electrolyzer.bt_mac ? 'success' : 'warning'}
                              style={{ whiteSpace: 'nowrap' }}
                            />
                            <Button
                              id="btn-save-bt-mac"
                              label="Salvar"
                              icon="pi pi-save"
                              size="small"
                              severity="success"
                              loading={btMacSaving}
                              disabled={btMacSaving || !btMacInput.trim()}
                              onClick={saveBtMac}
                            />
                          </div>
                        </div>
                        {/* --- Fim: Configuração do Dispositivo --- */}

                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: 5 }}>
                          <div className="p-inputgroup flex-1" style={{ marginRight: 5 }}>
                            <Button label="Sistema" size="small" />
                            <InputText className="p-inputtext-sm" variant="filled" value={electrolyzer.system_state.replace('Sistema ', '').replace('Sitema ', '')} />
                          </div>
                          <div className="p-inputgroup flex-1" style={{ marginRight: 5 }}>
                            <Button label="Manutenção" size="small" />
                            <InputText className="p-inputtext-sm" variant="filled" value={electrolyzer.maintenance.replace('Manutenção ', '')} />
                          </div>
                          <div className="p-inputgroup flex-1" >
                            <Button label="Polaridade" size="small" />
                            <InputText className="p-inputtext-sm" variant="filled" value={electrolyzer.polarity.replace('Polaridade', '')} />
                          </div>
                        </div>
                        {/*                         
                        <div><b>Etiqueta: </b>{electrolyzer?.label} </div>
                        <div><b>Estado do sistema: </b>{electrolyzer?.system_state}</div>
                        <div><b>Situação da manutenção: </b>{electrolyzer?.maintenance}</div>
                        <div><b>Polaridade: </b>{electrolyzer?.polarity}</div> */}
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                          <Divider align="center">
                            <span className="p-tag">Indicadores</span>
                          </Divider>
                          <p>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '120px' }}>
                                <div>Luz Verde</div>
                                <Button severity={electrolyzer.green_light ? "success" : "secondary"} rounded />
                              </div>
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '120px' }}>
                                <div>Luz Amarela</div>
                                <Button severity={electrolyzer.yellow_light ? "warning" : "secondary"} rounded />
                              </div>
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '120px' }}>
                                <div>Luz Vermelha</div>
                                <Button severity={electrolyzer.red_light ? "danger" : "secondary"} rounded />
                              </div>
                            </div>
                          </p>
                        </div>
                        <Divider align='center' layout="vertical"></Divider>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                          <Divider align="center">
                            <span className="p-tag">Horas</span>
                          </Divider>
                          <p>
                            <Knob value={Math.floor(electrolyzer?.minutes / 60)} max={500} />
                            {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        Dias
                        <Knob value={Math.floor(electrolyzer?.minutes / 60 / 24)} max={30} />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        Horas
                        <Knob value={Math.floor(electrolyzer?.minutes / 60 - Math.floor((electrolyzer?.minutes / 60) / 24) * 24)} max={24} />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        Minutos
                        <Knob value={electrolyzer?.minutes - Math.floor(electrolyzer?.minutes / 60) * 60} max={60} />
                        </div> */}
                            {/* <div>Tempo ligado: {electrolyzer?.minutes} minutos</div> */}
                          </p>
                        </div>


                      </div>
                    </div>
                }
              </>
            }
          </Panel>
          {electrolyzer
            &&
            <Panel headerTemplate={headerHistory}
              style={{ width: 850 }}
              toggleable
            >
              {isLoading &&
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '70vh' }}>
                  <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" animationDuration=".5s" />
                </div>
              }
              {!isLoading && (energyData.length > 1 ?
                <>
                  <div>{`Energia no período: ${Number(energy.toFixed(2))} Wh`}</div>
                  <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }} >
                    <Chart chartType="ComboChart" width="820px" height="250px" data={energyData} options={energyOptions} />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }} >
                    <Chart chartType="ComboChart" width="400px" height="250px" data={e1Data} options={e1Options} style={{ marginRight: 20 }} />
                    <Chart chartType="ComboChart" width="400px" height="250px" data={e2Data} options={e2Options} />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }} >
                    <Chart chartType="ComboChart" width='400px' height="250px" data={flowData} options={flowOptions} style={{ marginRight: 20 }} />
                    <Chart chartType="ComboChart" width='400px' height="250px" data={climateData} options={climateOptions} />
                  </div>
                </> :
                <>
                  {electrolyzer === null ?
                    <p>Selecione um eletrolizador!</p>
                    :
                    <>
                      {
                        dates === null || dates.length < 1 ?
                          <p>Selecione o período!</p>
                          :
                          <p>Sem dados para o eletrolizador no período informado!</p>
                      }
                    </>

                  }
                </>

              )}
            </Panel>
          }

        </div>

        <div>
          {/*
          <h2>Real-Time Data</h2>
          {stream.map((data, index) => (
            <p key={index}>Voltage: {data.voltage}, Current: {data.current}, Temperature: {data.temperature}</p>
          ))}
            */}
        </div>
      </PrimeReactProvider >
    </div >
  );
}

export default App;
